const Icon1 = ({className = '', ...props}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="66"
    height="66"
    fill="none"
    viewBox="0 0 66 66"
    className={className}
    {...props}
  >
    <path
      fill="url(#pattern0_111_1919)"
      d="M.605.604h64.704v64.704H.605z"
    ></path>
    <defs>
      <pattern
        id="pattern0_111_1919"
        width="1"
        height="1"
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#image0_111_1919" transform="scale(.01111)"></use>
      </pattern>
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACVElEQVR4nO3cT2oUURSF8bMKwYlGBZ0Z/Dd2Ioq4BR2ISxCXYoioQxWCuAQHrkJwoAQVjIOgETHpTj5paEgPrJH1Tr2qd34LuNx8NE2n69JSRIQPsA68BL4Ch/TnEPgCvAAuqmXAPeCA8vaBu2oRcMkUeTX2uloDbOH3Sq0BdgYI/U2tAY4GCH2k1jAQtSahTRLaJKFNEtokoU0S2iShTRLaJP8ZmgDfBwi9o9YArwcIvaXWAFeBmTHyDLisFgEPTLFnwH21DLgGvAF2CwTeXb5FXRn67xyNrpKKfiW0SUKbJLRJQpsk9MRCA2vABvCx5wOfg+XMx8BptRwauAn8pLwfwA21GBo4Y4q8GvuUGgy9id+GatO1qfqbv43fJ9Wma1P1N3+O31y16dpUmd+vsYcgoacxX6UXLa30/qpN8aIdSu+v2jAQFd5ftfHmPVZ6f9WGgajw/qqNN++x0vurNqUXZeTzezP2ECT0NOZrRCHm+DX5pdJn/LZVm65N1d/8p/g9UW26NlV/888Bv4yRF4/N1tRa6AXgjin2HnBbNXKEXnllP1/+ek3fFjOfAWdVK1fo5iW0SUKbJLRJQpsktElCmyS0SUJPLDQ5RC8fOofoOUSfVOhN/HKIbpJD9JafGe51LHuyp/mDUG2A9x27Pupp/iBUm+WTiX/5AzwETvzn/EGoNsvPuJOjGgFvmRjVCLhQ6CeBBqNaAdenFFs1A84D75gAjQFwa3mD8QH4zQipNSS0BwntQUJ7kC+VPMghugc5RPcgh+g+5BDdh9YP0SNCE/QXJURnmZvvcG4AAAAASUVORK5CYII="
        id="image0_111_1919"
        width="90"
        height="90"
        preserveAspectRatio="none"
      ></image>
    </defs>
  </svg>
);

export default Icon1;
